export default __webpack_public_path__ + "static/media/person_3@2x.fb6176c7.png";